import { Select } from 'antd';
import React from 'react';
import { useGetModulesQuery } from '../../graphql/schema';

interface Props {
  value?: string;
  onChange?: (id: string) => void;
}

interface Option {
  label: string;
  value: string;
}

const ModuleSelect = ({ value, onChange }: Props) => {
  const { data, loading } = useGetModulesQuery();

  const options: Option[] =
    data?.modules.map((item) => {
      return {
        label: item.title,
        value: item.id,
      };
    }) || [];

  return (
    <Select
      onChange={onChange}
      loading={loading}
      value={value}
      options={options}
      className="w-full"
    />
  );
};

export default ModuleSelect;
